import { Component, OnInit } from '@angular/core';
import type { Campaign } from '@app/_services/Instore'; // './././_services/Instore';
import {Sort} from '@angular/material/sort';

@Component({
  selector: 'app-modifycampaign',
  templateUrl: './modifycampaign.component.html',
  styleUrls: ['./modifycampaign.component.css']
})
export class ModifycampaignComponent implements OnInit {

  isStateWise = false;
  City: any = ['Option 1', 'Option 2', 'Option 3']
  instoreList: Campaign[] =  CAMPAIGN;
  sortedList: Campaign[] = [];
  page = 1;
  pageSize = 6;

  constructor() { }

  ngOnInit(): void {
    this.refreshRecognitions()  
  }

  refreshRecognitions() {
    this.sortedList = this.instoreList
    .map((recog, i) => ({id: i + 1, ...recog}))
    .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  showStateWise() {
    this.isStateWise  = true;
  }

  showDetail() {
    this.isStateWise  = false;
  }

  sortListItems(sort: Sort) {
  }
}

const CAMPAIGN: Campaign[] = 
[
  // {   
  //     name: 'Ad Spot: GF-LP4',
  //     showroom: 'Taramani',
  //     assets_type: 'Sony Led',
  //     size: '55" * 10"',
  //     cost:'75,000 Rs',
  //     startdate: '09 Jan,2016',
  //     enddate: '09 Jan,2016',
  //     images: "assets/images/dashboard/Layer 17.png" 
  //   },
  //   { 
  //     name: 'Ad Spot: GF-LP3',
  //     showroom: 'Taramani',
  //     type: 'Sony Led',
  //     size: '55" * 10"',
  //     cost:'75,000 Rs',
  //     startdate: '09 Jan,2016',
  //     enddate: '09 Jan,2016',
  //     images: "assets/images/dashboard/Layer 18.png" 
  //   },
  //   {  
  //     name: 'Ad Spot: GF-Lg7',
  //     showroom: 'Taramani',
  //     type: 'Sony Led',
  //     size: '55" * 10"',
  //     cost:'75,000 Rs',
  //     startdate: '09 Jan,2016',
  //     enddate: '09 Jan,2016',
  //     images: "assets/images/dashboard/Layer 18.png" 
  // },
  // {   
  //   name: 'Ad Spot: GF-LP4',
  //   showroom: 'Taramani',
  //   type: 'Sony Led',
  //   size: '55" * 10"',
  //   cost:'75,000 Rs',
  //   startdate: '09 Jan,2016',
  //   enddate: '09 Jan,2016',
  //   images: "assets/images/dashboard/Layer 17.png" 
  // }
];
